import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from 'views/CyberClub/components/Archive2022';
import CyberAssociationsidebar from '../CyberAssociationsidebar';


const CyberAssociation2025 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });

    const [config, setConfig] = useState({ base_image_archive_url_2025: '' });
    useEffect(() => {
        fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
            .then(response => response.json())
            .then(data => setConfig(data))
            .catch(error => console.error('Error fetching config:', error));
    }, []);

    const p1 = `${config.base_image_url_2025}/home/events-activities/association/Cyber/Cyber/1.webp`;
    const p2 = `${config.base_image_url_2025}/home/events-activities/association/Cyber/Cyber/2.webp`;
    const p3 = `${config.base_image_url_2025}/home/events-activities/association/Cyber/Cyber/3.webp`;
    const p4 = `${config.base_image_url_2025}/home/events-activities/association/Cyber/Cyber/4.webp`;
    const p5 = `${config.base_image_url_2025}/home/events-activities/association/Cyber/Cyber/5.webp`;
    const p6 = `${config.base_image_url_2025}/home/events-activities/association/Cyber/Cyber/6.webp`;
    const p7 = `${config.base_image_url_2025}/home/events-activities/association/Cyber/Cyber/7.webp`;
    const p8 = `${config.base_image_url_2025}/home/events-activities/association/Cyber/Cyber/8.webp`;
    const p9 = `${config.base_image_url_2025}/home/events-activities/association/Cyber/Cyber/9.webp`;

    const photos = [
        {
    src: p1,
    source: p1,
    rows: 1,
    cols: 1,
},
{
    src: p2,
    source: p2,
    rows: 1,
    cols: 1,
},
{
    src: p3,
    source: p3,
    rows: 1,
    cols: 1,
},
{
    src: p4,
    source: p4,
    rows: 1,
    cols: 1,
},
{
    src: p5,
    source: p5,
    rows: 1,
    cols: 1,
},
{
    src: p6,
    source: p6,
    rows: 1,
    cols: 1,
},
{
    src: p7,
    source: p7,
    rows: 1,
    cols: 1,
},
{
    src: p8,
    source: p8,
    rows: 1,
    cols: 1,
},
{
    src: p9,
    source: p9,
    rows: 1,
    cols: 1,
},


    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h4' align='center'>
                                    DESIGNING A BILLBOARD FOR SUSTAINABLE FUTURE
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                    Class: 6 to 8  Date: 9 September 2025
                                </Typography>

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                                   The Cyber Association (Juniors) of National Public School, Yeshwanthpur organised an activity ‘To Design a Billboard for Sustainable Future’ on 9 September 2025, Tuesday for the students of Classes 6 to 8. This activity inspired the young minds to dive deeper into technology and design an appealing Billboard for a Sustainable Future. 
                                    <br></br>
                                    The finalists, representing Athena, Aether, Aura and Astraea utilised various applications to design billboards relevant to the given topic. The event provided the students a platform to develop graphic designs which aimed at developing creativity, enhance visual communication and encouraged interdisciplinary learning along with a deep understanding of environmental responsibility. This activity also encouraged the students to think outside the box and come up with unique ideas to design a billboard. It enhanced their creative thinking and stressed the significance of teamwork, enriching their collaboration and communication skills.  
                                    <br></br>
                                </Typography>
                            </Box>
                            <Typography
                                variant={'h5'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                "Sustainable Future’ is not just a phrase - it is a call to action through Technology."
                                <br />
                            </Typography>

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 300 : 200}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>

                        <Box marginBottom={4}>
                            <CyberAssociationsidebar/>
                        </Box>

                        <Box marginBottom={4}>
                            <Archive2022 />
                        </Box>

                        {/* <SidebarNewsletter /> */}
                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default CyberAssociation2025;